// extracted by mini-css-extract-plugin
module.exports = {"donutChartContainer":"styles_donutChartContainer__ts80L"};